import styled from 'styled-components';

export const StyledAdminFilterSelectDropdown = styled.div`
  position: absolute;
  top: 2.3rem;
  border-radius: 8px;
  border: 1px solid
    ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.accent3)};
  background: ${(props) => (props.theme.id === 'dark' ? props.theme.bg3 : props.theme.bg2)};
  padding: 1rem;
  max-height: 25rem;
  overflow: auto;
  transform: translateX(-92%);

  @media screen and (max-width: 768px) {
    transform: translateX(-90%);
  }

  .admin-select-dropdown-element {
    display: inline-block;
    width: auto;
    min-width: 9rem;
    max-width: 40rem;
    padding-right: 4rem;
    cursor: pointer;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 150%; /* 27px */
    height: 2.4rem;
    &.clear {
      color: red;
    }

    &:hover {
      color: ${(props) => (props.theme.id === 'dark' ? props.theme.accent1 : props.theme.text2)};
    }

    @media screen and (max-width: 1440px) {
      font-size: 1.4rem;
    }

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
`;
